import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { tutorialAPI } from '../services/api';
import useApi from '../hooks/useApi';

const TutorialView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [currentSection, setCurrentSection] = useState(0);
    const [completed, setCompleted] = useState(false);

    const { data: tutorial, loading, error } = useApi(() => tutorialAPI.getTutorial(id));

    if (loading) {
        return (
            <div className="container mt-5">
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger" role="alert">
                    Error loading tutorial: {error.message}
                </div>
            </div>
        );
    }

    const handleComplete = async () => {
        try {
            await tutorialAPI.completeTutorial(id);
            setCompleted(true);
        } catch (error) {
            console.error('Error completing tutorial:', error);
        }
    };

    if (completed) {
        return (
            <div className="container mt-5">
                <div className="card">
                    <div className="card-body">
                        <h2 className="card-title">Tutorial Completed!</h2>
                        <p className="card-text">
                            Congratulations! You have completed this tutorial.
                        </p>
                        <button
                            className="btn btn-primary"
                            onClick={() => navigate('/tutorials')}
                        >
                            Return to Tutorials
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const section = tutorial.sections[currentSection];

    return (
        <div className="container mt-5">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="card-title mb-0">{tutorial.title}</h2>
                        <span className="badge bg-primary">
                            Section {currentSection + 1} of {tutorial.sections.length}
                        </span>
                    </div>

                    <div className="progress mb-4">
                        <div
                            className="progress-bar"
                            role="progressbar"
                            style={{
                                width: `${((currentSection + 1) / tutorial.sections.length) * 100}%`
                            }}
                        />
                    </div>

                    <div className="mb-4">
                        <h4>{section.title}</h4>
                        <div className="tutorial-content">
                            {section.content}
                        </div>
                    </div>

                    <div className="d-flex justify-content-between">
                        <button
                            className="btn btn-secondary"
                            onClick={() => setCurrentSection(currentSection - 1)}
                            disabled={currentSection === 0}
                        >
                            Previous Section
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                if (currentSection < tutorial.sections.length - 1) {
                                    setCurrentSection(currentSection + 1);
                                } else {
                                    handleComplete();
                                }
                            }}
                        >
                            {currentSection === tutorial.sections.length - 1 ? 'Complete Tutorial' : 'Next Section'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TutorialView; 